import styled from "styled-components";
import SendButton from "../../../../ui/button/Button";

export const StyledSendButton = styled(SendButton)`
  line-height: ${(props): string => props.theme.spacing(6.3)};
  font-size: ${(props): string => props.theme.spacing(3.7)};
`;
